import React, { FC } from 'react';

import { getClassNames } from './Flex.styles';
import { FlexProps } from './Flex.types';

const Flex: FC<FlexProps> = ({ children, ariaHidden, role, ...styleProps }) => (
  <div className={getClassNames(styleProps).flex} role={role} aria-hidden={ariaHidden}>
    {children}
  </div>
);

/**
 * A `Flex` component renders a flex-parent div with common flex-container styles.
 */
export default Flex;
